/* eslint-disable consistent-return */
/* eslint-disable no-return-await */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

interface ParamsProps {
  idAtendimento: string | null;
  idCorretor: string | null;
  nomeCorretor: string | null;
  idTipoVisita: string | null;
  descricaoTipoVisita: string | null;
  motivoAlteracao: string | null;
}

export function useEditarAtendimento(body: ParamsProps) {
  const updateData = async () => {
    const EDITAR_ATENDIMENTO = `${leadsWebEnviroment}/app-web/atendimentos/v1`;
    return await instance.put(EDITAR_ATENDIMENTO, body);
  };
  const query = useMutation({
    mutationFn: async () => await updateData(),
    mutationKey: ["editar_atendimento"],
    onError: (error: any) => {
      const notifications = error?.response?.data?.notifications;
      const errorMessages = Array.isArray(notifications)
        ? notifications.map((item: any) => `\n${item?.message}\n`)
        : ["\nErro desconhecido ao editar atendimento\n"];

      toast.error(errorMessages.join(""), { autoClose: 10000 });
    },
  });
  return query;
}
